import { importAll } from 'utils/helperFunctions';

export const rightMenuIcons = importAll(
  require.context('../../assets/rightMenuIcons', false, /\.(png|jpe?g|svg)$/),
);
